export const initCartItemProducts = (bundle) => {
  return bundle.products.map((product) => {
    const baseQty = product.quantity ?? 0;

    return {
      product_id: product.product_id,
      unit_price: product.unit_price,
      bundle_price: product.bundle_price,
      size: product.size || '',
      base_quantity: baseQty,
      addon_quantity: 0,
      total_quantity: baseQty,
      quantity: baseQty,
      is_individual_product: bundle.isIndividualProduct,
    };
  });
};

export const updateAddonQuantity = (
  products,
  productId,
  addonQty
) => {
  return products.map(p =>
    p.product_id === productId
      ? {
          ...p,
          addon_quantity: addonQty,
          total_quantity: p.base_quantity + addonQty,
          quantity: p.base_quantity + addonQty,
        }
      : p
  );
};

export const updateItemSize = (
  products,
  productId,
  size
) => {
  return products.map(p =>
    p.product_id === productId
      ? {
          ...p,
          size:size,
        }
      : p
  );
};
